var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reservation-detail tongxin-layout"
  }, [!_vm.isLoading && !_vm.reservation ? [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("預約詳情")]), _vm._m(0), _c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])] : _vm.isCancelSuccess ? [_c('div', {
    staticClass: "heading-icon",
    staticStyle: {
      "background-color": "#dc2626"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6L6 18M6 6l12 12"
    }
  })])]), _c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("已取消預約")]), _c('div', {
    staticClass: "profile-card"
  }, [_c('div', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("看診人")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.reservation.summary.patientName || '-'))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("診所名稱")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.reservation.summary.clinicName))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("看診日期")]), _c('span', {
    staticClass: "value text-green"
  }, [_vm._v(_vm._s(_vm.formattedDate))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("預約時段")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.reservation.summary.slotText))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("掛號類型")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.reservation.summary.typeName))])])])]), _c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.goBackToList
    }
  }, [_vm._v("返回預約列表")])] : _vm.reservation ? [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("預約詳情")]), _c('div', {
    staticClass: "profile-card"
  }, [_c('div', {
    staticClass: "profile-header"
  }, [_c('div', [_c('h2', {
    staticClass: "profile-name"
  }, [_vm._v(_vm._s(_vm.reservation.summary.clinicName))]), _vm.reservation.summary.patientName ? _c('div', {
    staticClass: "patient-name"
  }, [_vm._v(" " + _vm._s(_vm.reservation.summary.patientName) + " ")]) : _vm._e()]), _c('span', {
    staticClass: "status-badge",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.statusText))])]), _c('div', {
    staticClass: "profile-body"
  }, _vm._l(_vm.getProcessedInfoBlock(_vm.reservation.summary.infoBlock), function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "value",
      class: {
        'text-green': item.title === '就診時段'
      }
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)]), _vm.canCancel ? _c('button', {
    staticClass: "btn btn-danger btn-block",
    on: {
      "click": function click($event) {
        _vm.showCancelModal = true;
      }
    }
  }, [_vm._v(" 取消預約 ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])] : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showCancelModal ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showCancelModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("確認取消預約")]), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("取消後將無法恢復，確定要取消此預約嗎？")]), _c('div', {
    staticClass: "modal-body"
  }, _vm._l(_vm.getProcessedInfoBlock(_vm.reservation.summary.infoBlock), function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "disabled": _vm.isCancelling
    },
    on: {
      "click": function click($event) {
        _vm.showCancelModal = false;
      }
    }
  }, [_vm._v(" 返回 ")]), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isCancelling
    },
    on: {
      "click": _vm.cancelReservation
    }
  }, [_vm._v(" " + _vm._s(_vm.isCancelling ? '取消中...' : '確認取消') + " ")])])])]) : _vm._e()]), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("找不到此預約紀錄")])]);
}]

export { render, staticRenderFns }